import axios from "axios";
import { createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import qs from "qs";
import {
  Farmstype,
  Titudetype,
  Enviortype,
  CreateCounceltype,
} from "./posttypes";
import postSlice from "../reducer/post";
import { LoadCounseltype } from "../reducer/postpayloadtypes";
import { confirmAlert } from "react-confirm-alert";
export const API_BASE_URL = process.env.REACT_APP_API_ROOT;
console.log(" API_BASE_URL:", API_BASE_URL);

axios.defaults.baseURL = API_BASE_URL;

// 농장 정보 불러오는 api
export const LoadFarm = createAsyncThunk(
  "post/LoadFarm",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get("/ifactory/api/place/userplace");
      const savedtargetfarmId = await localStorage.getItem("targetfarm");

      if (savedtargetfarmId) {
        // 선택한 농장 정보 불러오는 api

        const filterFarm = response.data.find(
          (v: any) => v.placeId === Number(savedtargetfarmId)
        );
        thunkAPI.dispatch(postSlice.actions.targetFarm(filterFarm));
      } else {
        thunkAPI.dispatch(postSlice.actions.targetFarm(response.data[0]));
      }

      return response.data;
    } catch (error: any) {
      console.error(error);
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

// 사육일지 불러오는 api
export const LoadDiaryList = createAsyncThunk(
  "post/Diarylist",
  async (data: { [key: string]: any }, { rejectWithValue }) => {
    try {
      console.log("data : ", data);
      const query = Object.keys(data)
        .filter(
          (key) =>
            data[key] !== undefined && data[key] !== null && data[key] !== ""
        )
        .map((key) => (key === "size" ? "size=1000" : `${key}=${data[key]}`))
        .join("&");

      const response = await axios.get(`/ifactory/api/diary?${query}`);
      return response.data.results;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);

// detail 사육일지를 불러오는 api
export const TargetDiaryAct = createAsyncThunk(
  "post/TargetDiary",
  async (data: string | null, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/ifactory/api/diary/${data}`);
      return response.data;
    } catch (error: any) {
      console.error(error);
      console.log("err", error);
      return rejectWithValue(error.response.data);
    }
  }
);

// 날씨 데이터 불러오는 api
export const GetWeather = createAsyncThunk(
  "post/GetWeather",
  async (data: Titudetype, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/ifactory/api/weather/now?longitude=${data?.longitude}&latitude=${data?.latitude}`
      );
      return response.data.response.body.items.item;
    } catch (error: any) {
      console.error(error);
      return rejectWithValue(error.response.data);
    }
  }
);

// 날씨 데이터 불러오는 api
export const GetWeathertemp = createAsyncThunk(
  "post/GetWeathertemp",
  async (data: Titudetype, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `ifactory/api/weather/dateInfo?longitude=${data.longitude}&latitude=${data.latitude}`
      );
      return response.data;
    } catch (error: any) {
      console.error(error);
      return rejectWithValue(error.response.data);
    }
  }
);

// 환경 데이터(일별)를 불러오는 api
export const Getenvirdata = createAsyncThunk(
  "post/Getenvirdata",
  async (data: Enviortype, { rejectWithValue }) => {
    // console.log("***************Getenvirdata********************", data);

    if (data.tagIds === "") return;

    try {
      const response = await axios.get(
        `/ifactory/api/sensorrecord/pointavg?tagIds=${data.tagIds}&startDate=${data.startDate}&endDate=${data.endDate}&type=${data.type}&stdTime=${data.stdTime}`
      );

      if (
        response.data &&
        "EMPTYDATA" in response.data &&
        response.data.EMPTYDATA.length > 0
      ) {
        confirmAlert({
          title: `조회 기간 동안 ${response.data.EMPTYDATA} 값이 존재하지 않습니다.`,
          buttons: [{ label: "Yes" }],
        });
      }

      return response.data;
    } catch (error: any) {
      console.error(error);
      return rejectWithValue(error.response.data);
    }
  }
);

export const Getenvirdata2 = createAsyncThunk(
  "post/Getenvirdata2",
  async (data: Enviortype, { rejectWithValue }) => {
    if (data.tagIds === "") return;

    try {
      const response = await axios.get(
        `/ifactory/api/sensorrecord/pointavg?tagIds=${data.tagIds}&startDate=${data.startDate}&endDate=${data.endDate}&type=${data.type}&stdTime=${data.stdTime}`
      );

      if (
        response.data &&
        "EMPTYDATA" in response.data &&
        response.data.EMPTYDATA.length > 0
      ) {
        confirmAlert({
          title: `조회 기간 동안 ${response.data.EMPTYDATA} 값이 존재하지 않습니다.`,
          buttons: [
            {
              label: "Yes",
            },
          ],
        });
      }

      return response.data;
    } catch (error: any) {
      console.error(error);
      return rejectWithValue(error.response.data);
    }
  }
);

export const Getenvirdata3 = createAsyncThunk(
  "post/Getenvirdata3",
  async (data: Enviortype, { rejectWithValue }) => {
    if (data.tagIds === "") return;

    try {
      const response = await axios.get(
        `/ifactory/api/sensorrecord/pointavg?tagIds=${data.tagIds}&startDate=${data.startDate}&endDate=${data.endDate}&type=${data.type}&stdTime=${data.stdTime}`
      );

      if (
        response.data &&
        "EMPTYDATA" in response.data &&
        response.data.EMPTYDATA.length > 0
      ) {
        confirmAlert({
          title: `조회 기간 동안 ${response.data.EMPTYDATA} 값이 존재하지 않습니다.`,
          buttons: [
            {
              label: "Yes",
            },
          ],
        });
      }

      return response.data;
    } catch (error: any) {
      console.error(error);
      return rejectWithValue(error.response.data);
    }
  }
);

export const Getenvirdata4 = createAsyncThunk(
  "post/Getenvirdata4",
  async (data: Enviortype, { rejectWithValue }) => {
    if (data.tagIds === "") return;

    try {
      const response = await axios.get(
        `/ifactory/api/sensorrecord/pointavg?tagIds=${data.tagIds}&startDate=${data.startDate}&endDate=${data.endDate}&type=${data.type}&stdTime=${data.stdTime}`
      );

      if (
        response.data &&
        "EMPTYDATA" in response.data &&
        response.data.EMPTYDATA.length > 0
      ) {
        confirmAlert({
          title: `조회 기간 동안 ${response.data.EMPTYDATA} 값이 존재하지 않습니다.`,
          buttons: [
            {
              label: "Yes",
            },
          ],
        });
      }

      return response.data;
    } catch (error: any) {
      console.error(error);
      return rejectWithValue(error.response.data);
    }
  }
);
// ------------ 상담 일지 api

// 1. 상담일지 작성

export const CreateCounsel = createAsyncThunk(
  "post/CreateCounsel",
  async (datas: CreateCounceltype, thunkAPI) => {
    try {
      let datass = {
        title: datas.title,
        description: datas.description,
        privateYn: datas.privateYn,
      };
      const response = await axios.post(`/ifactory/api/counsel`, datass);

      const AccessToken = await localStorage.getItem("accessToken");

      for (let i = 0; i < datas.uploadimages.length; i++) {
        let file = datas.uploadimages[i];

        let formData = new FormData();

        formData.append("image", file as any);

        try {
          const imageresponse = await axios.post(
            `ifactory/api/file/uploadfile/counsel/${response.data.counselId}`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
        } catch (error) {
          console.log("error:", error);
        }
      }

      return response.data;
    } catch (error: any) {
      console.error(error);
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const LoadCounsel = createAsyncThunk(
  "post/LoadCounsel",
  async (data: string, { rejectWithValue }) => {
    try {
      const response = await axios.get(`ifactory/api/counsel/list?${data}`);
      return response.data;
    } catch (error: any) {
      console.error(error);
      return rejectWithValue(error.response.data);
    }
  }
);

export const LoadDetailCounsel = createAsyncThunk(
  "post/LoadDetailCounsel",
  async (data: string | null, { rejectWithValue }) => {
    try {
      const response = await axios.get(`ifactory/api/counsel/${data}`);
      return response.data;
    } catch (error: any) {
      console.error(error);
      return rejectWithValue(error.response.data);
    }
  }
);

export const LoadmultidiaryList = createAsyncThunk(
  "post/LoadmultidiaryList",
  async (data: string, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/ifactory/api/diary?${data}`);
      return response.data.results;
    } catch (error: any) {
      console.error(error);
      return rejectWithValue(error.response.data);
    }
  }
);
